import { lazy } from "react"

const AboutPage$$__react__lazy__component = lazy(() => 
    import("./AboutPage__original__module.mjs")
        .then(module => module.get_$$AboutPage$$AboutPage$$react__component$$3iupfptjvn0sm())
        .then(component => ({ default: component }))
)

export const get_$$AboutPage$$AboutPage$$react__component$$3iupfptjvn0sm = () => AboutPage$$__react__lazy__component